"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var frame_1 = require("../../frame");
var stompProtocolV1_0_1 = require("./stompProtocolV1_0");
// STOMP protocol with the version V1_1
var stompProtocolV1_1 = function () {
    var currentProtocol = stompProtocolV1_0_1.default();
    var hearbeatMsg = function () { return utils_1.BYTES.LF; };
    // [NACK Frame](http://stomp.github.com/stomp-specification-1.1.html#NACK)
    //
    // * 'messageID' & 'subscription' are MANDATORY.
    //
    // It is preferable to nack a message by calling 'nack()' directly on the
    // message handled by a subscription callback:
    //
    //     client.subscribe(destination,
    //       function(message) {
    //         // process the message
    //         // an error occurs, nack it
    //         message.nack();
    //       },
    //       {'ack': 'client'}
    //     );
    var nack = function (messageID, subscription, headers) {
        return frame_1.default.marshall('NACK', __assign({}, headers, { 'message-id': messageID, subscription: subscription }));
    };
    // [DISCONNECT Frame](http://stomp.github.com/stomp-specification-1.1.html#DISCONNECT)
    var disconnect = function (headers) {
        if (headers === void 0) { headers = {}; }
        return frame_1.default.marshall('DISCONNECT', headers);
    };
    return __assign({}, currentProtocol, { hearbeatMsg: hearbeatMsg, nack: nack, disconnect: disconnect });
};
exports.default = stompProtocolV1_1;
